// Guided tour for the /reversals page.
//
// REVERSALS_PAGE_OVERVIEW_TOUR_ID
//   Auto-runs once per viewer on the first visit to /reversals. Only exec
//   admins reach the page, so no per-permission gating is needed inside
//   the steps. The tour targets elements that render regardless of which
//   tab is active (the tab strip and the two tab buttons), so it works
//   without switching tabs programmatically. From step three onwards the
//   viewer is introduced to the vendor initiated flow, which is the newer
//   surface and the one most first-timers ask about.

export const REVERSALS_PAGE_OVERVIEW_TOUR_ID = 'reversals-page-overview-v1';

const visibleElementFor = (selector) => () => {
    const candidates = document.querySelectorAll(selector);
    for (const candidate of candidates) {
        if (candidate.offsetParent !== null) return candidate;
    }
    return null;
};

export const buildReversalsPageOverviewTourSteps = () => [
    {
        element: visibleElementFor('[data-tour="reversals-page-card"]'),
        title: 'Reversals live here',
        description: 'This is where you undo a payout that has already left the platform. There are two ways a reversal happens, so the page is split into two tabs.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: visibleElementFor('[data-tour="reversals-tab-admin-initiated"]'),
        title: 'Admin initiated',
        description: 'Reversals we run end to end. You start the reversal here, the system asks Safaricom to pull the money back on M-Pesa, and the ledger updates as soon as Safaricom confirms.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: visibleElementFor('[data-tour="reversals-tab-vendor-initiated"]'),
        title: 'Vendor initiated',
        description: 'Refunds where the vendor has already sent the money back on M-Pesa themselves. Safaricom is not involved on our side, so all you need to do here is record the incoming payment so the ledger catches up.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: visibleElementFor('[data-tour="reversals-tab-vendor-initiated"]'),
        title: 'How to record a vendor refund',
        description: 'Click Vendor initiated, then Record Refund in the top right. You will paste the Original Receipt ID, and the modal will look it up and show you who is being refunded before anything is saved.',
        side: 'bottom',
        align: 'start',
    },
];
